module.exports = __webpack_public_path__ + "img/home-globe-outer.0288371b.png";